module.exports = __webpack_public_path__ + "static/media/home-style-1.97afa35f.svg";